module.exports = __webpack_public_path__ + "img/fully_enclosed_and_detached_from_main_house_with_independent_roof.d83262d1.jpg";